import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import * as tokens from '@utmost.co/utmost-design-tokens';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '../../../Typography/Typography';
import Tooltip, { shouldEnableTooltip } from '../../../Tooltip';
import { CreatableOption, OptionTypeWithCode } from '../../types';
import { Embolden } from '../../../Embolden/Embolden';
import { isCreatableOption } from '../utils/guards';
import { SelectIconWrapper } from './SelectIconWrapper';
import { SecondaryLabels } from './SecondaryLabelItem';
import { SystemIcon } from '../../../Icon';

export const InnerMenuItem: React.FC<
  React.PropsWithChildren<{
    option: OptionTypeWithCode | CreatableOption;
    dataTest: string;
    searchTerm?: string;
    noWrapSubLabel?: boolean;
    selected?: boolean;
  }>
> = ({ option, dataTest, searchTerm, noWrapSubLabel, selected }) => {
  const [showTooltip, setTooltipState] = useState(false);
  const typographyRef = useRef<HTMLDivElement>(null);

  if (isCreatableOption(option)) {
    return <ListItemText data-test={`${dataTest}-list-item-create-value`} primary={option.creatableTitle} />;
  }

  let dataValue: string;
  try {
    dataValue = typeof option.value === 'object' ? JSON.stringify(option.value) : option.value;
  } catch (e) {
    dataValue = '';
  }
  return (
    <>
      {!!option.icon && <SelectIconWrapper>{option.icon}</SelectIconWrapper>}
      <ListItemText
        data-test={`${dataTest}-list-item`}
        data-test-label={option.label}
        data-value={dataValue}
        primary={
          <Typography
            dataTest="overflow-typography"
            tag="div"
            noWrap
            ref={typographyRef}
            onMouseEnter={() => setTooltipState(shouldEnableTooltip(typographyRef.current))}
          >
            <Tooltip title={option.label} dataTest="select-item-tooltip" placement="top" disabled={!showTooltip}>
              <Embolden term={searchTerm}>{option.label}</Embolden>
            </Tooltip>
            {selected && <StyledSystemIcon name="check" color={tokens.colorPrimary} width={24} height={24} />}
          </Typography>
        }
        secondary={<SecondaryLabels option={option} noWrapSubLabel={!!noWrapSubLabel} />}
        style={{ opacity: option.value !== null && typeof option.value !== 'undefined' ? 1 : 0.5 }}
        secondaryTypographyProps={{ component: 'span' }}
      />
    </>
  );
};

const StyledSystemIcon = styled(SystemIcon)`
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
`;
